import React from 'react';
import Button from 'react-bootstrap/Button';
import withSounds from 'containers/withSounds';
import LeftArrow from './resources/arrow-left.svg';
import RightArrow from './resources/arrow-right.svg';
import './PaginationControls.css';

const BtnWithSounds = withSounds({ mouseEnterSound: true })(Button);

const PaginationControls = ({
  controls,
  activeIndex,
  onPaginationChange,
  buttonsEnabled = true,
  withSound = true,
  displayControlTitle = false,
  displayControlTitleKey
}) => {
  const ButtonClass = withSound ? BtnWithSounds : Button;
  const clampedIndex = Math.max(Math.min(activeIndex, controls.length - 1), 0);
  return (
    <React.Fragment>
      <div className="pagination-container">
        <ButtonClass
          className="prev"
          variant="custom"
          onClick={() => onPaginationChange(clampedIndex - 1)}
          disabled={!buttonsEnabled || clampedIndex === 0}
        >
          <img src={LeftArrow} alt="Previous Page" />
        </ButtonClass>
        <div className="pagination-dots">
          {displayControlTitle && (
            <div className="pagination-dots-content">
              {controls[activeIndex][displayControlTitleKey]}
            </div>
          )}
          <div className="pagination-dots-section">
            {controls.map((_, i) => (
              <ButtonClass
                key={i}
                className={i === clampedIndex ? 'btn-active' : 'btn-inactive'}
                variant="custom"
                onClick={() => onPaginationChange(i)}
                disabled={!buttonsEnabled}
              >
                <div className="visiblity-hide">{i + 1}</div>
              </ButtonClass>
            ))}
          </div>
        </div>
        <ButtonClass
          className="next"
          variant="custom"
          onClick={() => onPaginationChange(clampedIndex + 1)}
          disabled={!buttonsEnabled || clampedIndex === controls.length - 1}
        >
          <img src={RightArrow} alt="Next Page" />
        </ButtonClass>
      </div>
    </React.Fragment>
  );
};

export default PaginationControls;
